import React from 'react';

export default () => (
  <section className="ItemPending">
    <p>Loading...</p>
  </section>
);



// WEBPACK FOOTER //
// ./src/app/item-customisations/item-pending.js